/* unplugin-vue-components disabled */import { render } from "./ai-text.vue?vue&type=template&id=22f4a98b&scoped=true"
import script from "./ai-text.vue?vue&type=script&lang=js"
export * from "./ai-text.vue?vue&type=script&lang=js"

import "./ai-text.vue?vue&type=style&index=0&id=22f4a98b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f4a98b"],['__file',"src/components/ai-chat-v2/ai-assistant/ai-input/ai-text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22f4a98b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22f4a98b', __exports__)) {
    api.reload('22f4a98b', __exports__)
  }
  
  module.hot.accept("./ai-text.vue?vue&type=template&id=22f4a98b&scoped=true", () => {
    api.rerender('22f4a98b', render)
  })

}


export default __exports__